import * as RoutePathConstants from '../../../../../../constants/RoutePathConstants'
import { API_BASE_URL } from '../../../../../../common/utils/commonUrl'
import http from '../../../../../../common/utils/http'
import { DOWNLOAD_FILE, UPLOAD_FILE } from '../../../../../../common/utils/uploadFileUtil'
import moment from 'moment'

export default {
  data () {
    return {
      newsDetails: null
    }
  },
  methods: {
    getNewsDetails (id) {
      http.get(API_BASE_URL + '/api/wxoa/member/memberBasis/getNewsDetails?id=' + id).then(
        res => {
          this.newsDetails = res.data.data
          this.newsDetails.img = this.getImg(res.data.data.codeToFileIds.categoryIcon[0])
        }
      )
    },
    // 获取图片
    getImg (imgCode) {
      let img = `${DOWNLOAD_FILE}${imgCode}?X-Authorization=${localStorage.getItem('token')}`
      return img
    },
    dateFormat (time) {
      return time ? moment(time).format('YYYY/MM/DD') : ''
    },

  },
  mounted () {
    this.getNewsDetails(this.$route.query.id)
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/points-mail-home-page-new/views/practical-skills-details/practical-skills-details.js